import styled from "styled-components";
import { tint } from "polished";
import { hideOnMaxWidth } from "src/styles/mixins";
import { SignInButton, SignUpButton } from "@clerk/clerk-react";

export const StyledAuthButtons = styled("div")({
  display: "flex",
  height: "2.7rem",
  border: "1px solid rgba(206, 206, 234)",
  borderRadius: "15px",
  background: "white",
});

export const StyledLoginButton = styled(SignInButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "8px 20px",
  fontSize: "14px",
  textDecoration: "none",
  color: theme.colorPrimary,
  fontWeight: 500,
  borderRadius: "15px",
  border: "none",
  cursor: "pointer",
}));

export const StyledSignUpButton = styled(SignUpButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "8px 20px",
  fontSize: "14px",
  textDecoration: "none",
  fontWeight: 500,
  borderRadius: "15px",
  border: "none",
  cursor: "pointer",
  background: `linear-gradient(90deg, ${theme.colorPrimary}, ${tint(0.2, theme.colorPrimary)})`,
  color: "white",
  ...hideOnMaxWidth(theme.screenSMMax),
  "&:hover": {
    opacity: 0.9,
  },
}));

export const StyledGreetingText = styled("span")(({ theme }) => ({
  padding: "0 8px",
  whiteSpace: "nowrap",
  ...hideOnMaxWidth(theme.screenSMMax),
}));

export const ProfileIconStyled = styled("span")(({ theme }) => ({
  color: theme.colorPrimary,
  fontSize: "18px",
  cursor: "pointer",
}));
